import React, { useState, useEffect } from 'react';
import DashboardPage from '../pages/DashboardPage';
import SalesPage from '../pages/SalesPage';
import ExpensesPage from '../pages/ExpensesPage';
import UsersPage from '../pages/UsersPage';
import CaissePage from '../pages/CaissePage';
import ProductsPage from '../pages/ProductsPage';
import ClientsPage from '../pages/ClientsPage';
import { IconDashboard, IconCaisse, IconSales, IconExpenses, IconUsers, IconLogout, IconProducts } from './Icons';

const navItems = [
  { id: 'dashboard', icon: IconDashboard, label: 'Tableau de bord' },
  { id: 'caisse', icon: IconCaisse, label: 'Caisse' },
  { id: 'sales', icon: IconSales, label: 'Ventes' },
  { id: 'expenses', icon: IconExpenses, label: 'Dépenses' },
];

const adminNavItems = [
  { id: 'clients', icon: IconUsers, label: 'Clients' },
  { id: 'products', icon: IconProducts, label: 'Produits' },
  { id: 'users', icon: IconUsers, label: 'Utilisateurs' },
];

function DashboardLayout({ apiUrl, auth, onLogout }) {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isAdmin = auth.user.role === 'admin';
  const permissions = JSON.parse(auth.user.permissions || '{}');

  const handleNavigate = (pageId) => {
    setCurrentPage(pageId);
    setSidebarOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) setSidebarOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard': return <DashboardPage apiUrl={apiUrl} auth={auth} />;
      case 'caisse': return <CaissePage apiUrl={apiUrl} auth={auth} />;
      case 'sales': return <SalesPage apiUrl={apiUrl} auth={auth} />;
      case 'expenses': return <ExpensesPage apiUrl={apiUrl} auth={auth} isAdmin={isAdmin} permissions={permissions} />;
      case 'clients': return isAdmin ? <ClientsPage apiUrl={apiUrl} auth={auth} /> : null;
      case 'products': return isAdmin ? <ProductsPage apiUrl={apiUrl} auth={auth} /> : null;
      case 'users': return isAdmin ? <UsersPage apiUrl={apiUrl} auth={auth} /> : null;
      default: return <DashboardPage apiUrl={apiUrl} auth={auth} />;
    }
  };

  const allNavItems = isAdmin ? [...navItems, ...adminNavItems] : navItems;

  return (
    <div className="app-layout">
      <button
        className="sidebar-toggle"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        {sidebarOpen ? '✕' : '☰'}
      </button>

      <div
        className={`sidebar-overlay ${sidebarOpen ? 'visible' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />

      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="5" />
            <line x1="12" y1="1" x2="12" y2="3" />
            <line x1="12" y1="21" x2="12" y2="23" />
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
            <line x1="1" y1="12" x2="3" y2="12" />
            <line x1="21" y1="12" x2="23" y2="12" />
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
          </svg>
          <span className="text">Gestion de Plage</span>
        </div>
        <div className="sidebar-nav">
          {allNavItems.map(item => {
            const IconComp = item.icon;
            return (
              <button
                key={item.id}
                className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
                onClick={() => handleNavigate(item.id)}
              >
                <span className="icon"><IconComp size={20} /></span>
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{auth.user.username[0].toUpperCase()}</div>
            <span>{auth.user.username} ({isAdmin ? 'Admin' : 'Employé'})</span>
          </div>
          <button className="logout-btn" onClick={onLogout}>
            <span className="icon"><IconLogout size={18} /></span>
            <span>Se déconnecter</span>
          </button>
        </div>
      </div>

      <div className="main-content">
        {renderPage()}
      </div>
    </div>
  );
}

export default DashboardLayout;
